module.exports = __webpack_public_path__ + "static/dinosaurbath1-8ad0f773df82a583ae696d2bb22ca389.png";